// extracted by mini-css-extract-plugin
module.exports = {"TextWhiteShadow":"Banner_TextWhiteShadow__A4x_y"};